import { fetchZatcaApps } from "./constants";
import {  useBaseModal, ZatcaClient } from "services";
import { useMemo, useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { Alert, Col, Row } from "reactstrap";
import { FormGroup, } from "components/common";
import Select from "react-select";
import { NotificationManager } from "react-notifications";



export const useZatcaAppsChecker = (t, isZatcaSubscribed, setSelectedZatcaApp, CanReport) => {
    const [zatcaApps, setZatcaApps] = useState(null);
    const zatca = ZatcaClient()
    const [, ZatcaAppToggle, ZatcaAppModal] = useBaseModal()

    useEffect(async () => {
        if(!CanReport || !isZatcaSubscribed) return
        const _apps = await fetchZatcaApps(zatca)
        setZatcaApps(_apps)
        if (_apps?.length==1) {
            setSelectedZatcaApp(_apps[0].value)
        }
    }, [])

    const selectApp = (selectedZatcaApp) => {
        if(!isZatcaSubscribed || zatcaApps.length==0 || !CanReport) return true
        if (zatcaApps?.length==1 || selectedZatcaApp) {
            return true
        }
        ZatcaAppToggle()
        return false

    }


    const handleSubmit = (selectedZatcaApp, callback) => {
        if (!selectedZatcaApp){
            NotificationManager.error(t("Please fill in All the Details"));
            return
        }
        callback({zatcaApp: selectedZatcaApp}); 
        ZatcaAppToggle()
    }
    

    const ZatcaAppsComponent = useMemo(() => {
        return ({selectedZatcaApp, callbackFunc}) => (
            <ZatcaAppModal title={t('ZATCA application selection')} action={t("Confirm")} HandleSubmit={() => {handleSubmit(selectedZatcaApp, callbackFunc)}}>
                <Alert color="warning">
                    <Trans>You have multiple zatca OnBoardings, Please select one</Trans>
                </Alert>
                <Row>
                    <Col className="col-12">
                        <FormGroup label={t("Select a ZATCA application") + " *"} >
                            <Select placeholder={`${t("Select a ZATCA application" )}`} options={zatcaApps} value={selectedZatcaApp} onChange={(e) => {setSelectedZatcaApp(e?.value || "")}} Isclearable={false}/>
                        </FormGroup>
                    </Col>
                </Row>
            </ZatcaAppModal>
        )
    }, [ZatcaAppModal, zatcaApps])

    return [selectApp, ZatcaAppsComponent]
}

